import { useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import Dialog from 'src/componentes/dialog';
import Tab from 'src/componentes/tabs/tab';
import Tabs from 'src/componentes/tabs/tabs';
import useAuth from 'src/hooks/useAuth';
import Button from 'src/componentes/button';
import distinctBy from 'src/utils/ArrayDistinctBy';
import DicionarioRiscoView from 'src/paginas/gestao-risco/DicionarioRiscos';

const DicionarioRiscoSearchComponent = ({ selectedCallback, selectedItems, checkSelected, ...rest }) => {
  const intl = useIntl();

  const [data, setData] = useState(selectedItems || []);

  const dialogRef = useRef();
  const { terms: resources } = useAuth();

  const handleClose = () => {
    if (dialogRef?.current) dialogRef?.current.close();
  };

  const handleSelect = (key, itens) => {
    const newList = itens ? distinctBy(itens, 'id') : [];

    setData(
        newList?.map((x) => {
          x.idLookup = `C-${x.id}`;
          return x;
        }) || [],
    );
  };

  const handleSave = () => {
    if (selectedCallback)
      selectedCallback([...data]);
    handleClose();
  };

  const actions = [
    <Button onClick={handleClose} color="secondary">
      {intl.formatMessage({ id: 'label.cancelar' })}
    </Button>,
    <Button
      className="ml-2"
      type="primary"
      onClick={handleSave}
      htmlType="submit"
    >
      {intl.formatMessage({ id: 'label.confirmar' })}
    </Button>,
  ];

  const dicionarioRiscosList = data?.dicionarioRiscos;

  return (
    <Dialog
      ref={dialogRef}
      width={"90%"}
      maxHeight="80%"
      minWidth={600}
      minHeight={"60%"}
      actions={actions}
      padContent
      onRequestClose={handleClose}
      {...rest}
    >
      <Tabs>
        <Tab
          label={intl.formatMessage({
            id: 'labelDicionarioRiscos',
          }, { riscos: resources.riscos })}
        >
          <DicionarioRiscoView
            multiple={false}
            select
            selectRealTime
            selectedCallback={(itens) => handleSelect('dicionarioRiscos', itens)}
            selectedItems={dicionarioRiscosList}
            selectedIds={dicionarioRiscosList}
            parameters={{ ...rest.parameters }}
            showNew={false}
            checkSelected={checkSelected}
          />
        </Tab>
      </Tabs>
    </Dialog>
  );
};

export default DicionarioRiscoSearchComponent;
